<script setup>
import DocSection from '@/components/Docs/Section.vue'
import CodeBlock from '@/components/Docs/CodeBlock.vue'
import JsonBlock from '@/components/Docs/JsonBlock.vue'
import Jumbo from '@/components/Docs/Jumbo.vue'
  
</script>

<template>
  <div class="row">
    <doc-section title="Authentication">
      <template v-slot:left>
Authentication is a crucial aspect of accessing our API, and most endpoints require it. This section outlines the primary way of authenticating an application by use of API keys.
<br><br>
To authenticate using an API key, simply include the API key as a query parameter in any request to the api. The API key serves as a unique identifier for your application or user account, granting access to the endpoints and associated resources. API keys can be generated from your <router-link to="/account">profile screen</router-link>, once logged in.
<br><br>
Keep in mind to store the key in a safe location, as anyone with access to it, will gain access to your account. Once generated, you will not be able to view the key again. You can manage active keys from your profile screen.
<br><br>
      </template>

      <template v-slot:right>
        <code-block title="Authentication" text>
          https://api.webscout.io/hello?apikey={YOUR_APIKEY}
        </code-block>
      </template>
    </doc-section>
  </div>
</template>

<style scoped>
</style>
